"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchLocalizations = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _immutable = require("@ori/fetching/immutable");
var _i18n = require("@ori/i18n");
var _logger = require("../../logger");
var _translationKeys = require("./translationKeys");
const logger = _logger.mainLogger.createChild('useFetchLocalizations');
const fetcher = async ([, fetchParams]) => {
  // TODO: Replace with fetchTranslationsWithNamespaces
  const {
    translations,
    error: fetchTranslationsError
  } = await (0, _i18n.fetchTranslations)({
    ...fetchParams,
    keys: _translationKeys.translationKeys
  });

  // When error happens the function wont throw, but returns that error instead
  if (fetchTranslationsError) {
    logger.error(fetchTranslationsError);
    throw fetchTranslationsError;
  }
  return translations;
};
const useFetchLocalizations = () => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    onlineUrl
  } = (0, _configurationManager.useServiceUrls)(['online']);
  const fetchOptions = {
    baseUrl: onlineUrl ?? (typeof window === 'undefined' ? '' : window.location.origin),
    currentLanguage: language
  };
  return (0, _immutable.useSWRImmutable)(onlineUrl ? ['chat-localizations', fetchOptions] : null, fetcher);
};
exports.useFetchLocalizations = useFetchLocalizations;
